import { render } from "./AboutUs.vue?vue&type=template&id=63d744e9&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=63d744e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d744e9"]])

export default __exports__